import { render, staticRenderFns } from "./Territorial.vue?vue&type=template&id=778c6b54&scoped=true"
import script from "./Territorial.vue?vue&type=script&lang=js"
export * from "./Territorial.vue?vue&type=script&lang=js"
import style0 from "./Territorial.vue?vue&type=style&index=0&id=778c6b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778c6b54",
  null
  
)

export default component.exports